import { getFilterByType } from "@evolved/views";

export const validateFilter = (type, value) => {
  const { validate } = getFilterByType(type);

  return validate(value);
};
